import { UserInfoContainer } from "../../containers/Profile/UserInfoContainer";

export function UserInfoPage() {
    return (
        <UserInfoContainer />
    )
}
